import classNames from 'classnames'
import React from 'react'
import injectStyles from 'react-jss'
import {
  PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED_ENUM,
  PERSONAL_DATA_CHANGE_REQUEST_STATUS_CANCELLED_ENUM,
  PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED_ENUM,
  PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED_ENUM,
  PTO_REQUEST_STATUS_EXPIRED_ENUM,
} from '../../../shared/constants'
import styles from './styles'

const ActionBlock = ({ item, onReject, onApprove, classes }) => {
  const renderStatusButtons = () => {
    if (item.status === PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED_ENUM) {
      return (
        <div
          className={classNames({
            [classes.acceptedButtonIfDocAccepted]: true,
            [classes.button]: true,
            [classes.acceptButton]: true,
          })}
        >
          Requested
        </div>
      )
    }
    if (item.status === PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED_ENUM) {
      return (
        <div
          className={classNames({
            [classes.button]: true,
            [classes.acceptButton]: true,
          })}
        >
          Approved
        </div>
      )
    }
    if (item.status === PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED_ENUM) {
      return (
        <div
          className={classNames({
            [classes.button]: true,
            [classes.rejectButton]: true,
          })}
        >
          Rejected
        </div>
      )
    }
    if (item.status === PERSONAL_DATA_CHANGE_REQUEST_STATUS_CANCELLED_ENUM) {
      return (
        <div
          className={classNames({
            [classes.button]: true,
            [classes.rejectButton]: true,
          })}
        >
          Cancelled
        </div>
      )
    }
    if (item.status === PTO_REQUEST_STATUS_EXPIRED_ENUM) {
      return (
        <div
          className={classNames({
            [classes.button]: true,
            [classes.rejectButton]: true,
          })}
        >
          Expired
        </div>
      )
    }
  }

  return (
    <div className={classes.container}>
      {item.status === PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED_ENUM ? (
        <div className={classes.statusButtonsContainer}>
          <div
            onClick={() => onApprove(item)}
            className={classNames({
              [classes.buttonContainer]: true,
              [classes.acceptWithHover]: true,
              [classes.button]: true,
            })}
          >
            {'Approve'}
          </div>
          <div
            onClick={() => onReject(item)}
            className={classNames({
              [classes.buttonContainer]: true,
              [classes.rejectWithHover]: true,
              [classes.button]: true,
            })}
          >
            {'Reject'}
          </div>
        </div>
      ) : (
        renderStatusButtons()
      )}
    </div>
  )
}

export default injectStyles(styles)(ActionBlock)
